import { Box, Text, Flex } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Popup } from 'react-map-gl';

import { formatDistanceUnit, formatYearMonthDayTime } from 'utils/format';

interface IGeoCoordinatesPopupProps {
  item: any;
  activeGeoCoordinatePopup: any;
  setActiveGeoCoordinatePopup: (data: any) => void;
}

const GeoCoordinatesPopup: React.FC<IGeoCoordinatesPopupProps> = ({
  item,
  activeGeoCoordinatePopup,
  setActiveGeoCoordinatePopup,
}) => {
  const { t } = useTranslation(['whoIsWorking', 'common']);

  return (
    <Popup
      latitude={activeGeoCoordinatePopup?.latitude}
      longitude={activeGeoCoordinatePopup?.longitude}
      closeButton={true}
      closeOnClick={false}
      onClose={() => setActiveGeoCoordinatePopup(null)}
      anchor="top"
      className="mapbox-popup-wrapper"
    >
      <Box>
        <Text fontSize="xs" fontWeight="semibold">
          {item?.first_name} {item?.last_name}{' '}
          <Text as="span" textTransform="lowercase">
            {t('common:at')}
          </Text>{' '}
          {activeGeoCoordinatePopup?.location_time
            ? formatYearMonthDayTime(activeGeoCoordinatePopup?.location_time ?? null)
            : '- '}
        </Text>
        <Flex justifyContent="space-between">
          <Text fontSize="xs" color="gray.500">
            {t('common:accuracy')}:{' '}
            <Text as="span" fontWeight="semibold">
              {activeGeoCoordinatePopup?.accuracy ? activeGeoCoordinatePopup?.accuracy.toFixed(2) + ' m' : '- '}
            </Text>
          </Text>
          <Text fontSize="xs" color="gray.500" ml="1">
            {t('common:speed')}:{' '}
            <Text as="span" fontWeight="semibold">
              {!isNaN(activeGeoCoordinatePopup?.speed)
                ? formatDistanceUnit(activeGeoCoordinatePopup?.speed).replace('miles', 'mph').replace('km', 'k/h')
                : '- '}
            </Text>
          </Text>
        </Flex>
      </Box>
    </Popup>
  );
};

export default GeoCoordinatesPopup;
